interface NameParts {
  name?: string;
  surname?: string;
  patronymic?: string;
}

const nbsp = '\u00A0';

/** Фамилия Имя Отчество - порядок для русского отображения */
export const formatFullName = (user: NameParts): string => {
  return [user.surname, user.name, user.patronymic]
    .map((part) => part?.trim())
    .filter(Boolean)
    .join(nbsp);
};

/** Краткое имя для списка чатов: Имя Ф. */
export const formatShortName = (user: NameParts, userId?: number): string => {
  const name = user.name?.trim() || '';
  const surnameInitial = user.surname?.trim()
    ? `${user.surname.trim().charAt(0)}.`
    : '';

  if (!name && !surnameInitial) {
    return userId ? `Пользователь${nbsp}#${userId}` : 'Пользователь';
  }

  return [name, surnameInitial].filter(Boolean).join(nbsp);
};

export const formatDisplayName = (user: NameParts, userId?: number): string => {
  const full = formatFullName(user);
  if (full) return full;
  if (userId) return `Пользователь${nbsp}#${userId}`;
  return 'Пользователь';
};
